import produce from 'immer';
import { ReducerAction } from 'store/modules/types';
import { toSelect } from 'utils/genericFunctions';
import { Types, consultaTipo } from './types';

export const INITIAL_STATE: consultaTipo = {
	status: 0,
	data: [],
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): consultaTipo {
	return produce(state, draft => {
		switch (action.type) {
			case Types.CONSULTA_TIPO_REQUEST: {
				break;
			}

			case Types.CONSULTA_TIPO_SUCCESS: {
				draft.status = action.payload.status;
				const select = toSelect(
					action.payload.data.tipos,
					'descricao',
					'longId',
				);
				draft.data = select;
				break;
			}

			case Types.CONSULTA_TIPO_FAILURE: {
				draft.status = action.payload.status;
				draft.data = action.payload.data;
				break;
			}

			default:
		}
		return draft;
	});
}
